if (['de','it'].includes(document.documentElement.lang.toLowerCase().split('-')[0])) {
(() => {
  'use strict';
  const tx=value=>(document.documentElement.lang.toLowerCase().split('-')[0]==='de'?globalThis.AsteriaGermanCopy:globalThis.AsteriaItalianCopy)?.text(value)??String(value??'');

  function esc(value) {
    return String(tx(value))
      .replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;')
      .replaceAll('"','&quot;').replaceAll("'","&#039;");
  }

  function routeRoot() {
    const root = globalThis.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function centerByKey(key) {
    return globalThis.AsteriaChakraData?.centers?.find(c => c.key === key) || null;
  }

  function stoneCard(stone, locale) {
    const routes = globalThis.AsteriaZodiacData?.routes || {};
    const route = routes[stone] || {};
    const media = globalThis.AsteriaStoneMedia?.[route.profile] || {};
    const href = route.collection ? routeRoot() + 'collections/' + encodeURIComponent(route.collection) : routeRoot() + 'pages/contact';
    return '<article class="ae-chakra__stone-card">' +
      '<a class="ae-chakra__stone-media" href="' + esc(href) + '">' +
      (media.image ? '<img src="' + esc(media.image) + '" alt="' + esc(media.titleTr && media.titleTr !== stone ? (locale==='tr'?media.titleTr:media.titleEn)||stone : stone) + '" loading="lazy" decoding="async">' : '') +
      '</a><div class="ae-chakra__stone-copy"><h4><a style="font:inherit;color:inherit;text-decoration:none" href="' + esc(href) + '">' + esc(stone) + '</a></h4>' +
      (media.titleTr && media.titleTr!==stone ? '<small class="ae-chakra__family">'+esc(locale==='tr'?'Görsel: '+media.titleTr+' ailesi':tx('Image: ')+(media.titleEn||media.titleTr)+tx(' family'))+'</small>':'') +
      '<a href="' + esc(href) + '">' + esc(route.collection ? (locale==='tr'?'Tasarımları keşfet →':tx('Explore designs →')) : (locale==='tr'?'Özel tasarım için iletişime geç →':tx('Contact us for a custom design →'))) + '</a></div></article>';
  }

  function renderCollections(host, center, locale) {
    const routes = globalThis.AsteriaZodiacData?.routes || {};
    const media = globalThis.AsteriaCollectionMedia || {};
    const seen = new Set();
    const cards = [];
    for (const stone of center.stones) {
      const route = routes[stone];
      const slug = route?.collection;
      const item = slug ? media[slug] : null;
      if (!slug || !item || seen.has(slug)) continue;
      seen.add(slug);
      const title = locale === 'tr' ? item.titleTr : item.titleEn;
      const href = routeRoot() + 'collections/' + slug;
      cards.push('<article class="ae-chakra__collection-card"><a href="' + esc(href) + '">' +
        '<span class="ae-chakra__collection-media">' + (item.image ? '<img src="' + esc(item.image) + '" alt="' + esc(title) + '" loading="lazy" decoding="async">' : '') + '</span>' +
        '<div><h4>' + esc(title) + '</h4><p>' + esc(locale === 'tr' ? 'Koleksiyonu keşfet →' : tx('Explore collection →')) + '</p></div>' +
      '</a></article>');
      if (cards.length >= 4) break;
    }
    host.innerHTML = cards.join('');
  }

  function themesTr(center) {
    return center.themesTr.map(theme => theme === 'Köklenme' ? 'Aidiyet' : theme);
  }

  function setShare(root, center, locale) {
    const share = root.querySelector('[data-ae-result-share]');
    if (!share) return;
    const themes = locale === 'tr' ? themesTr(center) : (locale==='it'?center.themesIt:center.themesEn);
    share.dataset.shareText = tx(locale === 'tr'
      ? 'ASTERIA ELITE\nBugünkü odağım: ' + center.sanskrit + ' · ' + center.tr + '\n' + themes.join(' • ')
      : 'ASTERIA ELITE\nMy focus today: ' + center.sanskrit + ' · ' + (document.documentElement.lang==='it'?center.it:center.en) + '\n' + themes.join(' • '));
    share.dataset.shareUrl = globalThis.location.href;
    share.hidden = false;
  }

  const colors = {muladhara:'#c75e59',svadhisthana:'#d49755',manipura:'#d8b763',anahata:'#79ad86',vishuddha:'#74a8c4',ajna:'#8d91c7',sahasrara:'#b19acd'};
  const extraTr = {
    muladhara:'Günün değişkenliği içinde sana sağlam bir zemin sunan şeyleri düşün: güvendiğin insanlar, küçük alışkanlıkların ve kendine ayırdığın alan. Bugünkü niyetin, bunlardan birine daha bilinçli yer açmak olabilir.',
    svadhisthana:'Yaratıcılık bazen küçük bir merakla başlar. Sana keyif veren bir uğraşa dönmek, yeni bir fikre alan açmak veya günlük ritminde küçük bir değişiklik yapmak bu temayı kendi yaşamında düşünmenin yollarıdır.',
    manipura:'Bugün kendi kararına güvenmek istediğin bir alanı seç. Büyük bir adım gerekmeyebilir; ertelediğin küçük bir işi tamamlamak veya önceliğini açıkça belirlemek, bu temaya kişisel bir anlam katabilir.',
    anahata:'Kendine ve yakınlarına nasıl yaklaşmak istediğini düşün. Dinlemek, bir teşekkür paylaşmak veya kendi sınırlarını nazikçe ifade etmek, sevgi ve uyum temasına günlük hayatında yer açabilir.',
    vishuddha:'Söylemek istediğin şeyi sade ve açık bir cümleyle ifade etmeyi dene. Kendi sesine alan açarken karşındakini de dinlemek, bu temayı karşılıklı anlayışla buluşturabilir.',
    ajna:'Günün telaşından biraz uzaklaşıp bir konuya yeniden bak. İlk izleniminin yanında bildiklerini ve sorularını da değerlendirmek, bu temayı kişisel bir düşünme alanına dönüştürebilir.',
    sahasrara:'Senin için anlamlı olan değerleri ve yaşamında bağ kurduğun şeyleri düşün. Küçük bir sessizlik anı veya sevdiğin bir uğraş, bu temayı kendi deneyiminle keşfetmene eşlik edebilir.'
  };
  const lotusTiles={muladhara:[36,24],svadhisthana:[435,24],manipura:[845,24],anahata:[1240,24],vishuddha:[220,465],ajna:[655,465],sahasrara:[1080,465]};
  function lotus(root,key) {
    const tile=lotusTiles[key];
    return '<span class="ae-chakra__lotus" aria-hidden="true" style="--lotus-x:'+(-tile[0]/380*100)+';--lotus-y:'+(-tile[1]/380*100)+'"><img src="'+esc(root.dataset.lotusUrl)+'" width="1672" height="941" alt="" decoding="async"></span>';
  }
  function renderGeometry(root, selectedKey) {
    root.querySelectorAll('[data-ae-chakra-node]').forEach(node => {
      const center=centerByKey(node.dataset.aeChakraNode);
      node.style.setProperty('--chakra-color',colors[center.key]);
      node.innerHTML='<i>'+lotus(root,center.key)+'</i><span>'+esc(root.dataset.locale==='tr'?center.tr:(document.documentElement.lang==='it'?center.it:center.en))+'</span>';
      node.classList.toggle('is-active', node.dataset.aeChakraNode === selectedKey);
    });
  }

  function render(root, center, locale) {
    const result = root.querySelector('[data-ae-chakra-result]');
    const commerce = root.querySelector('[data-ae-chakra-commerce]');
    if (!result || !commerce) return;

    root.querySelector('[data-ae-chakra-sanskrit]').textContent = tx(center.sanskrit);
    root.querySelector('[data-ae-chakra-name]').textContent = tx(locale === 'tr' ? center.tr : (document.documentElement.lang==='it'?center.it:center.en));
    root.querySelector('[data-ae-chakra-color]').textContent = tx(locale === 'tr' ? center.colorTr : (locale==='it'?center.colorIt:center.colorEn));
    root.querySelector('[data-ae-chakra-element]').textContent = tx(locale === 'tr' ? center.elementTr : (locale==='it'?center.elementIt:center.elementEn));
    root.querySelector('[data-ae-chakra-copy]').textContent = tx(locale === 'tr' ? center.copyTr : (locale==='it'?center.copyIt:center.copyEn));
    root.querySelector('[data-ae-chakra-themes]').innerHTML =
      (locale === 'tr' ? themesTr(center) : (locale==='it'?center.themesIt:center.themesEn)).map(x => '<span>' + esc(x) + '</span>').join('');

    root.querySelector('[data-ae-chakra-extra]').textContent=tx(locale==='tr'?extraTr[center.key]:'');
    root.querySelector('[data-ae-chakra-extra]').hidden=locale!=='tr';
    root.querySelector('[data-ae-chakra-symbol]').style.color=colors[center.key];
    root.querySelector('[data-ae-chakra-symbol]').innerHTML=lotus(root,center.key);
    root.querySelectorAll('[data-ae-chakra-pick]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.aeChakraPick===center.key)));
    root.querySelectorAll('[data-ae-theme-pick]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.aeThemePick===center.key)));
    renderGeometry(root, center.key);
    setShare(result, center, locale);

    const collectionHost = root.querySelector('[data-ae-chakra-collections]');
    const stoneHost = root.querySelector('[data-ae-chakra-stones]');
    renderCollections(collectionHost, center, locale);
    globalThis.AsteriaChakraProducts?.render(root.querySelector('[data-ae-chakra-products]'), center.stones, locale, root.dataset.currency);
    stoneHost.innerHTML = center.stones.map(stone => stoneCard(stone, locale)).join('');

    root.querySelector('[data-ae-chakra-stone-heading]').textContent = tx(locale === 'tr'
      ? center.tr + ' ile ilişkilendirilen taşlar'
      : tx('Stones associated with the ') + (document.documentElement.lang==='it'?center.it:center.en));

    result.hidden = false;
    commerce.hidden = false;
    result.scrollIntoView({behavior:'smooth',block:'start'});
  }

  function bind(root) {
    const locale = root.dataset.locale === 'tr' ? 'tr' : root.dataset.locale === 'it' ? 'it' : root.dataset.locale === 'de' ? 'de' : 'en';
    const data = globalThis.AsteriaChakraData;
    if (!data) return;

    const direct = root.querySelector('[data-ae-chakra-direct]');
    const themes = root.querySelector('[data-ae-chakra-theme-choices]');

    direct.innerHTML = [...data.centers].reverse().map(c =>
      '<button type="button" aria-pressed="false" style="--chakra-color:'+colors[c.key]+'" data-ae-chakra-pick="' + esc(c.key) + '"><i>'+lotus(root,c.key)+'</i><strong>' +
      esc(c.sanskrit) + '</strong><span>' + esc(locale === 'tr' ? c.tr : (locale==='it'?c.it:c.en)) + '</span></button>'
    ).join('');

    themes.innerHTML = data.themeChoices.map(t =>
      '<button type="button" aria-pressed="false" data-ae-theme-pick="' + esc(t.center) + '">' +
      esc(locale === 'tr' ? (t.key === 'grounding' ? 'Güven ve Aidiyet' : t.tr) : (locale==='it'?t.it:t.en)) + '</button>'
    ).join('');

    root.addEventListener('click', event => {
      const chakra = event.target.closest('[data-ae-chakra-pick]');
      const theme = event.target.closest('[data-ae-theme-pick]');
      const key = chakra?.dataset.aeChakraPick || theme?.dataset.aeThemePick;
      if (!key) return;
      const center = centerByKey(key);
      if (center) render(root, center, locale);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-ae-chakra]').forEach(bind);
  });
})();
} else {
(() => {
  'use strict';

  function esc(value) {
    return String(value == null ? '' : value)
      .replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;')
      .replaceAll('"','&quot;').replaceAll("'","&#039;");
  }

  function routeRoot() {
    const root = globalThis.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function centerByKey(key) {
    return globalThis.AsteriaChakraData?.centers?.find(c => c.key === key) || null;
  }

  function stoneCard(stone, locale) {
    const routes = globalThis.AsteriaZodiacData?.routes || {};
    const route = routes[stone] || {};
    const media = globalThis.AsteriaStoneMedia?.[route.profile] || {};
    const href = route.collection ? routeRoot() + 'collections/' + encodeURIComponent(route.collection) : routeRoot() + 'pages/contact';
    return '<article class="ae-chakra__stone-card">' +
      '<a class="ae-chakra__stone-media" href="' + esc(href) + '">' +
      (media.image ? '<img src="' + esc(media.image) + '" alt="' + esc(media.titleTr && media.titleTr !== stone ? (locale==='tr'?media.titleTr:media.titleEn)||stone : stone) + '" loading="lazy" decoding="async">' : '') +
      '</a><div class="ae-chakra__stone-copy"><h4><a style="font:inherit;color:inherit;text-decoration:none" href="' + esc(href) + '">' + esc(stone) + '</a></h4>' +
      (media.titleTr && media.titleTr!==stone ? '<small class="ae-chakra__family">'+esc(locale==='tr'?'Görsel: '+media.titleTr+' ailesi':'Image: '+(media.titleEn||media.titleTr)+' family')+'</small>':'') +
      '<a href="' + esc(href) + '">' + esc(route.collection ? (locale==='tr'?'Tasarımları keşfet →':'Explore designs →') : (locale==='tr'?'Özel tasarım için iletişime geç →':'Contact us for a custom design →')) + '</a></div></article>';
  }

  function renderCollections(host, center, locale) {
    const routes = globalThis.AsteriaZodiacData?.routes || {};
    const media = globalThis.AsteriaCollectionMedia || {};
    const seen = new Set();
    const cards = [];
    for (const stone of center.stones) {
      const route = routes[stone];
      const slug = route?.collection;
      const item = slug ? media[slug] : null;
      if (!slug || !item || seen.has(slug)) continue;
      seen.add(slug);
      const title = locale === 'tr' ? item.titleTr : item.titleEn;
      const href = routeRoot() + 'collections/' + slug;
      cards.push('<article class="ae-chakra__collection-card"><a href="' + esc(href) + '">' +
        '<span class="ae-chakra__collection-media">' + (item.image ? '<img src="' + esc(item.image) + '" alt="' + esc(title) + '" loading="lazy" decoding="async">' : '') + '</span>' +
        '<div><h4>' + esc(title) + '</h4><p>' + esc(locale === 'tr' ? 'Koleksiyonu keşfet →' : 'Explore collection →') + '</p></div>' +
      '</a></article>');
      if (cards.length >= 4) break;
    }
    host.innerHTML = cards.join('');
  }

  function themesTr(center) {
    return center.themesTr.map(theme => theme === 'Köklenme' ? 'Aidiyet' : theme);
  }

  function setShare(root, center, locale) {
    const share = root.querySelector('[data-ae-result-share]');
    if (!share) return;
    const themes = locale === 'tr' ? themesTr(center) : center.themesEn;
    share.dataset.shareText = locale === 'tr'
      ? 'ASTERIA ELITE\nBugünkü odağım: ' + center.sanskrit + ' · ' + center.tr + '\n' + themes.join(' • ')
      : 'ASTERIA ELITE\nMy focus today: ' + center.sanskrit + ' · ' + center.en + '\n' + themes.join(' • ');
    share.dataset.shareUrl = globalThis.location.href;
    share.hidden = false;
  }

  const colors = {muladhara:'#c75e59',svadhisthana:'#d49755',manipura:'#d8b763',anahata:'#79ad86',vishuddha:'#74a8c4',ajna:'#8d91c7',sahasrara:'#b19acd'};
  const extraTr = {
    muladhara:'Günün değişkenliği içinde sana sağlam bir zemin sunan şeyleri düşün: güvendiğin insanlar, küçük alışkanlıkların ve kendine ayırdığın alan. Bugünkü niyetin, bunlardan birine daha bilinçli yer açmak olabilir.',
    svadhisthana:'Yaratıcılık bazen küçük bir merakla başlar. Sana keyif veren bir uğraşa dönmek, yeni bir fikre alan açmak veya günlük ritminde küçük bir değişiklik yapmak bu temayı kendi yaşamında düşünmenin yollarıdır.',
    manipura:'Bugün kendi kararına güvenmek istediğin bir alanı seç. Büyük bir adım gerekmeyebilir; ertelediğin küçük bir işi tamamlamak veya önceliğini açıkça belirlemek, bu temaya kişisel bir anlam katabilir.',
    anahata:'Kendine ve yakınlarına nasıl yaklaşmak istediğini düşün. Dinlemek, bir teşekkür paylaşmak veya kendi sınırlarını nazikçe ifade etmek, sevgi ve uyum temasına günlük hayatında yer açabilir.',
    vishuddha:'Söylemek istediğin şeyi sade ve açık bir cümleyle ifade etmeyi dene. Kendi sesine alan açarken karşındakini de dinlemek, bu temayı karşılıklı anlayışla buluşturabilir.',
    ajna:'Günün telaşından biraz uzaklaşıp bir konuya yeniden bak. İlk izleniminin yanında bildiklerini ve sorularını da değerlendirmek, bu temayı kişisel bir düşünme alanına dönüştürebilir.',
    sahasrara:'Senin için anlamlı olan değerleri ve yaşamında bağ kurduğun şeyleri düşün. Küçük bir sessizlik anı veya sevdiğin bir uğraş, bu temayı kendi deneyiminle keşfetmene eşlik edebilir.'
  };
  const lotusTiles={muladhara:[36,24],svadhisthana:[435,24],manipura:[845,24],anahata:[1240,24],vishuddha:[220,465],ajna:[655,465],sahasrara:[1080,465]};
  function lotus(root,key) {
    const tile=lotusTiles[key];
    return '<span class="ae-chakra__lotus" aria-hidden="true" style="--lotus-x:'+(-tile[0]/380*100)+';--lotus-y:'+(-tile[1]/380*100)+'"><img src="'+esc(root.dataset.lotusUrl)+'" width="1672" height="941" alt="" decoding="async"></span>';
  }
  function renderGeometry(root, selectedKey) {
    root.querySelectorAll('[data-ae-chakra-node]').forEach(node => {
      const center=centerByKey(node.dataset.aeChakraNode);
      node.style.setProperty('--chakra-color',colors[center.key]);
      node.innerHTML='<i>'+lotus(root,center.key)+'</i><span>'+esc(root.dataset.locale==='tr'?center.tr:center.en)+'</span>';
      node.classList.toggle('is-active', node.dataset.aeChakraNode === selectedKey);
    });
  }

  function render(root, center, locale) {
    const result = root.querySelector('[data-ae-chakra-result]');
    const commerce = root.querySelector('[data-ae-chakra-commerce]');
    if (!result || !commerce) return;

    root.querySelector('[data-ae-chakra-sanskrit]').textContent = center.sanskrit;
    root.querySelector('[data-ae-chakra-name]').textContent = locale === 'tr' ? center.tr : center.en;
    root.querySelector('[data-ae-chakra-color]').textContent = locale === 'tr' ? center.colorTr : center.colorEn;
    root.querySelector('[data-ae-chakra-element]').textContent = locale === 'tr' ? center.elementTr : center.elementEn;
    root.querySelector('[data-ae-chakra-copy]').textContent = locale === 'tr' ? center.copyTr : center.copyEn;
    root.querySelector('[data-ae-chakra-themes]').innerHTML =
      (locale === 'tr' ? themesTr(center) : center.themesEn).map(x => '<span>' + esc(x) + '</span>').join('');

    root.querySelector('[data-ae-chakra-extra]').textContent=locale==='tr'?extraTr[center.key]:'';
    root.querySelector('[data-ae-chakra-extra]').hidden=locale!=='tr';
    root.querySelector('[data-ae-chakra-symbol]').style.color=colors[center.key];
    root.querySelector('[data-ae-chakra-symbol]').innerHTML=lotus(root,center.key);
    root.querySelectorAll('[data-ae-chakra-pick]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.aeChakraPick===center.key)));
    root.querySelectorAll('[data-ae-theme-pick]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.aeThemePick===center.key)));
    renderGeometry(root, center.key);
    setShare(result, center, locale);

    const collectionHost = root.querySelector('[data-ae-chakra-collections]');
    const stoneHost = root.querySelector('[data-ae-chakra-stones]');
    renderCollections(collectionHost, center, locale);
    globalThis.AsteriaChakraProducts?.render(root.querySelector('[data-ae-chakra-products]'), center.stones, locale, root.dataset.currency);
    stoneHost.innerHTML = center.stones.map(stone => stoneCard(stone, locale)).join('');

    root.querySelector('[data-ae-chakra-stone-heading]').textContent = locale === 'tr'
      ? center.tr + ' ile ilişkilendirilen taşlar'
      : 'Stones associated with the ' + center.en;

    result.hidden = false;
    commerce.hidden = false;
    result.scrollIntoView({behavior:'smooth',block:'start'});
  }

  function bind(root) {
    const locale = root.dataset.locale === 'tr' ? 'tr' : 'en';
    const data = globalThis.AsteriaChakraData;
    if (!data) return;

    const direct = root.querySelector('[data-ae-chakra-direct]');
    const themes = root.querySelector('[data-ae-chakra-theme-choices]');

    direct.innerHTML = [...data.centers].reverse().map(c =>
      '<button type="button" aria-pressed="false" style="--chakra-color:'+colors[c.key]+'" data-ae-chakra-pick="' + esc(c.key) + '"><i>'+lotus(root,c.key)+'</i><strong>' +
      esc(c.sanskrit) + '</strong><span>' + esc(locale === 'tr' ? c.tr : c.en) + '</span></button>'
    ).join('');

    themes.innerHTML = data.themeChoices.map(t =>
      '<button type="button" aria-pressed="false" data-ae-theme-pick="' + esc(t.center) + '">' +
      esc(locale === 'tr' ? (t.key === 'grounding' ? 'Güven ve Aidiyet' : t.tr) : t.en) + '</button>'
    ).join('');

    root.addEventListener('click', event => {
      const chakra = event.target.closest('[data-ae-chakra-pick]');
      const theme = event.target.closest('[data-ae-theme-pick]');
      const key = chakra?.dataset.aeChakraPick || theme?.dataset.aeThemePick;
      if (!key) return;
      const center = centerByKey(key);
      if (center) render(root, center, locale);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-ae-chakra]').forEach(bind);
  });
})();
}
